import { Trans, useTranslation } from 'react-i18next';
import { APP_LINKS } from '@/helpers/links';
import { CONTACT_EMAIL, CONTACT_PHONE } from '@/helpers/constants';
import { WhatsAppChatLink } from '@/components/WhatsAppChatLink';
import Logo from '@scramble/design-system/logo/scramble_logo_black.svg';
import {
  AppVersion,
  MyLink,
  PaymentMethodIcons,
  SocialLinks,
} from '@scramble/ui';
import s from './index.module.scss'

export const AppFooter = () => {
  const { t } = useTranslation('footer');
  return (
    <footer className={s.footer}>
      <div className="g-container">
        <div className={s.links}>
          <div className={s.link_group}>
            <h4 className="f-body-sm f-500">{t('company')}</h4>
            <ul className={s.list}>
              <li>
                <MyLink href={APP_LINKS.home} isExternal newWindow={false}>
                  {t('home')}
                </MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.investing}>
                  {t('investment_round')}
                </MyLink>
              </li>
              <li>
                <MyLink
                  href={APP_LINKS.promoRoundsHistory}
                  isExternal
                  newWindow={false}
                >
                  {t('rounds_history')}
                </MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.blog} isExternal newWindow={false}>
                  {t('blog')}
                </MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.affiliate}>
                  {t('affiliate_programme')}
                </MyLink>
              </li>
            </ul>
          </div>

          <div className={s.link_group}>
            <h4 className="f-body-sm f-500">{t('help')}</h4>
            <ul className={s.list}>
              <li>
                <MyLink href={APP_LINKS.help}>{t('help')}</MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.helpLoanTerms()}>
                  {t('loan_terms')}
                </MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.complaints}>
                  {t('investor_complaints')}
                </MyLink>
              </li>
            </ul>
          </div>

          <div className={s.link_group}>
            <h4 className="f-body-sm f-500">{t('legal')}</h4>
            <ul className={s.list}>
              <li>
                <MyLink href={APP_LINKS.privacyPolicy} isExternal>
                  {t('privacy_policy')}
                </MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.termOfUse} isExternal>
                  {t('terms_of_use')}
                </MyLink>
              </li>
              <li>
                <MyLink
                  href={APP_LINKS.docAssignmentAgreementGeneralTerms}
                  isExternal
                >
                  {t('assignment_agreement')}
                </MyLink>
              </li>
              <li>
                <MyLink
                  href={APP_LINKS.docAnnexToSubordinatedLoansAgreement}
                  isExternal
                >
                  {t('annex_guarantee_letter')}
                </MyLink>
              </li>
            </ul>
          </div>

          <div className={s.link_group}>
            <h4 className="f-body-sm f-500">{t('support')}</h4>
            <div className={s.list}>
              <MyLink className={s.phone} href={APP_LINKS.phone} isExternal>
                {CONTACT_PHONE}
              </MyLink>
              <WhatsAppChatLink />
              <MyLink
                className={s.email}
                href={`mailto:${CONTACT_EMAIL}`}
                isExternal
              >
                {CONTACT_EMAIL}
              </MyLink>
            </div>
          </div>
        </div>

        <div className={s.information}>
          <div className={s.information_left}>
            <div className={s.logo}>
              <img src={Logo} alt="logo" width={112} height={20} />
            </div>
          </div>
          <div className={s.information_right}>
            <PaymentMethodIcons />
          </div>
        </div>

        <div className={s.bottom}>
          <div className={s.bottom_left}>
            <div className={s.reserved}>
              {t('scramble_ou_all_rights_reserved', {
                year: new Date().getFullYear(),
              })}
            </div>
            <div className={s.bottom_links}>
              Terms of Service
              <span className="f-body-sm f-400">&</span>
              Privacy Policy
            </div>
          </div>
          <div className={s.bottom_right}>
            <SocialLinks />
          </div>
        </div>

        <div className={s.registration}>{t('scramble_ou_registered')}</div>
        <div className={s.registration}>
          <Trans
            ns="footer"
            i18nKey="scramble_ou_not_crowdfunding"
            components={{ Bold: <span className="f-600" /> }}
          />
        </div>
        <AppVersion color="var(--Bg-Neutral-Primary-Light, #F4F4F5)" />
      </div>
    </footer>
  );
};
